module.exports = __webpack_public_path__ + "static/media/flashdeal-icon.bfcbe053.svg";